export const styles = {
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    display: "flex",
  },
  days: {
    color: "#959595",
    fontWeight: "500",
    textAlign: "center",
    width: 40,
  },
};
